import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: ${props => `${props.theme.whiteLabel.spacing.sp8} 12px`};
  background-color: ${props => props.theme.colors.blue.tone100};
  border-radius: 4px;
  gap: 13px;
`

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp4};
`
